import { z } from "zod";

export const signInMethodSchema = z.enum(["qr", "manual", "emergency"]);

export const signInVerificationStatusSchema = z.enum([
  "verified",
  "outside_geofence",
  "location_unavailable",
]);

// Capture: geofence is evaluated synchronously in the decider, so the computed
// flag/distance/verification ride on the WorkerSignedIn event itself.
export const workerSignedIn = z.object({
  type: z.literal("WorkerSignedIn"),
  signInId: z.string().min(1),
  userId: z.string().min(1),
  siteId: z.string().min(1),
  lat: z.number().nullable().optional(),
  lon: z.number().nullable().optional(),
  method: signInMethodSchema,
  flagged: z.boolean(),
  distanceFromSite: z.number().nullable(),
  verificationStatus: signInVerificationStatusSchema,
  cameraAvailable: z.boolean().nullable().optional(),
  locationAvailable: z.boolean().nullable().optional(),
  signedInAt: z.date(),
});

export const workerSignedOut = z.object({
  type: z.literal("WorkerSignedOut"),
  signInId: z.string().min(1),
  signedOutAt: z.date(),
});

export const signInFlagUpdated = z.object({
  type: z.literal("SignInFlagUpdated"),
  signInId: z.string().min(1),
  flagged: z.boolean(),
});

export const workerAutoSignedOut = z.object({
  type: z.literal("WorkerAutoSignedOut"),
  signInId: z.string().min(1),
  signedOutAt: z.date(),
});

export const signInEvents = [
  workerSignedIn,
  workerSignedOut,
  signInFlagUpdated,
  workerAutoSignedOut,
] as const;
